import { render, staticRenderFns } from "./AssessBanner.vue?vue&type=template&id=3cd0746c&scoped=true&"
import script from "./AssessBanner.vue?vue&type=script&lang=js&"
export * from "./AssessBanner.vue?vue&type=script&lang=js&"
import style0 from "./AssessBanner.vue?vue&type=style&index=0&id=3cd0746c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd0746c",
  null
  
)

export default component.exports